import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { RegisterContainerComponent } from './containers/register-container/register-container.component'
import { AuthMainContainerComponent } from './containers/auth-main-container/auth-main-container.component'
import { LoginContainerComponent } from './containers/login-container/login-container.component'
import {
  ForgotPasswordContainerComponent
} from './containers/forgot-password-container/forgot-password-container.component'
import { SetPasswordContainerComponent } from './containers/set-password-container/set-password-container.component'
import {
  EmailConfirmationContainerComponent
} from './containers/email-confirmation-container/email-confirmation-container.component'
import { ConfirmationContainerComponent } from './containers/confirmation-container/confirmation-container.component'
import { appRoutes, pathUrl } from '@adex/shared/routing/routes'
import {
  ForgotPasswordConfirmationContainerComponent
} from './containers/forgot-password-confirmation-container/forgot-password-confirmation-container.component'
import {
  ResetSetPasswordContainerComponent
} from './containers/reset-set-password-container/reset-set-password-container.component'
import { GoogleAuthComponent } from './components/google-auth/google-auth.component'


const routes: Routes = [
  {
    path: pathUrl(appRoutes.auth.main),
    component: AuthMainContainerComponent,
    children: [
      {
        path: pathUrl(appRoutes.auth.register),
        component: RegisterContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.login),
        component: LoginContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.forgotPassword),
        component: ForgotPasswordContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.setPassword),
        component: SetPasswordContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.emailConfirmation),
        component: EmailConfirmationContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.confirmation),
        component: ConfirmationContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.forgotPasswordConfirmation),
        component: ForgotPasswordConfirmationContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.resetSetPassword),
        component: ResetSetPasswordContainerComponent
      },
      {
        path: pathUrl(appRoutes.auth.googleAuth),
        component: GoogleAuthComponent
      }
    ]
  },
  {
    path: pathUrl(appRoutes.auth.main, 1),
    redirectTo: pathUrl(appRoutes.auth.login, 2),
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: pathUrl(appRoutes.auth.login, 2),
    pathMatch: 'full'
  }
]


@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class AuthRoutingModule {
}
